var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "my-4" },
    [
      _vm._l(_vm.model, function(item) {
        return _c(
          "div",
          { key: item.id, staticClass: "rounded p-3 bg-gray my-3" },
          [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [
                  _vm._v("Tipo de Documento:")
                ]),
                _c("div", [
                  _vm._v(_vm._s(_vm._f("empty")(item.documentType.name)))
                ])
              ]),
              _vm.isItemOther(item.documentType.id)
                ? _c("div", { staticClass: "col-12 col-md" }, [
                    _c("div", { staticClass: "data-name" }, [
                      _vm._v("Título del documento:")
                    ]),
                    _c("div", [_vm._v(_vm._s(_vm._f("empty")(item.other)))])
                  ])
                : _vm._e(),
              _c("div", { staticClass: "col-12 col-md" }, [
                _c("div", { staticClass: "data-name" }, [_vm._v("Archivo:")]),
                _c("div", [_vm._v(_vm._s(_vm._f("empty")(item.document.name)))])
              ]),
              _c("div", { staticClass: "col-12 col-md" }, [
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-end mt-1" },
                  [
                    !_vm.isReadOnly
                      ? _c("action-button", {
                          attrs: {
                            i: "fas fa-times-circle",
                            variant: "outline-danger mr-2"
                          },
                          on: {
                            click: function($event) {
                              return _vm.remove(item)
                            }
                          }
                        })
                      : _vm._e(),
                    _c("action-button", {
                      attrs: { i: "fas fa-file-download", variant: "success" },
                      on: {
                        click: function($event) {
                          return _vm.download(item.document)
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ])
          ]
        )
      }),
      _vm.canAdd
        ? _c(
            "div",
            { staticClass: "rounded p-3 bg-gray my-3" },
            [
              _c("validation-observer", {
                ref: "supportingDocumentsForm",
                attrs: { novalidate: "" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function({ failed }) {
                        return [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "div",
                              { staticClass: "col-12 col-md" },
                              [
                                _c("validation-provider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ errors }) {
                                          return [
                                            _c("custom-drop-down", {
                                              class: {
                                                "was-Invalidated-select": !!errors[0]
                                              },
                                              attrs: {
                                                "custom-error-msg":
                                                  "El campo es requerido.",
                                                error: errors[0],
                                                fieldkey: "id",
                                                fieldname: "name",
                                                label: "Tipo de Documento:",
                                                options: _vm.documentTypes,
                                                placeholder: "Seleccione"
                                              },
                                              model: {
                                                value:
                                                  _vm.innerModel.documentType,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.innerModel,
                                                    "documentType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "innerModel.documentType"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            ),
                            _vm.isOther
                              ? _c(
                                  "div",
                                  { staticClass: "col-12 col-md" },
                                  [
                                    _c("validation-provider", {
                                      attrs: { rules: "required" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c("custom-input", {
                                                  attrs: {
                                                    "custom-error-msg":
                                                      "El campo es requerido.",
                                                    error: errors[0],
                                                    label:
                                                      "Nombre del Documento:"
                                                  },
                                                  model: {
                                                    value: _vm.innerModel.other,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.innerModel,
                                                        "other",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "innerModel.other"
                                                  }
                                                })
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        true
                                      )
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass: "col-12",
                                class: {
                                  "col-md-5": !_vm.isOther,
                                  "col-md-4": _vm.isOther
                                }
                              },
                              [
                                _c("div", { staticClass: "data-name mb-2" }, [
                                  _vm._v(" Archivo: ")
                                ]),
                                _c("validation-provider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ errors }) {
                                          return [
                                            _c("custom-file-input", {
                                              ref: "fileUpload",
                                              attrs: {
                                                accept: _vm.allowedFiles,
                                                "custom-error-msg":
                                                  "El documento es requerido",
                                                "display-style": "normal",
                                                error: errors[0],
                                                "max-size":
                                                  _vm.params.fileMaxSize,
                                                "on-download": () => {}
                                              },
                                              model: {
                                                value: _vm.innerModel.file,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.innerModel,
                                                    "file",
                                                    $$v
                                                  )
                                                },
                                                expression: "innerModel.file"
                                              }
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ],
                              1
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "col-12 col-md-3 d-flex justify-content-center align-items-center",
                                class: {
                                  "pt-4": !failed
                                }
                              },
                              [
                                _c("action-button", {
                                  attrs: {
                                    i: "fas fa-times-circle",
                                    text: "Cancelar",
                                    variant: "outline-danger mr-2"
                                  },
                                  on: { click: _vm.cancel }
                                }),
                                _c("action-button", {
                                  attrs: {
                                    i: "fas fa-save",
                                    text: "Guardar",
                                    variant: "success"
                                  },
                                  on: { click: _vm.save }
                                })
                              ],
                              1
                            )
                          ])
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  754849799
                )
              })
            ],
            1
          )
        : !_vm.isReadOnly
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-end" },
            [
              _c("action-button", {
                attrs: {
                  i: "fas fa-file-plus",
                  text: "Añadir",
                  variant: "success"
                },
                on: {
                  click: function($event) {
                    _vm.showAdd = true
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }